import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  Box,
  Table,
  TableBody,
} from '@material-ui/core';
import { KeyboardArrowUp, KeyboardArrowDown } from '@material-ui/icons';
import PropTypes from 'prop-types';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

export default function TableRowChildren({ detach, header, data, onCallback }) {
  const classes = useRowStyles();

  const [open, setOpen] = useState(true);

  return (
    <>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" style={{ fontWeight: 600 }}>
          {detach}
        </TableCell>
      </TableRow>
      {data.map((item, index) => (
        <TableRow
          hover
          key={index}
          onClick={() => onCallback(item)}
          style={{ display: open ? 'table-row' : 'none', cursor: 'pointer' }}
        >
          <TableCell />
          {header.map((h, key) => (
            <TableCell key={key} align={h.align}>
              {h.formatted ? h.formatted(item[h.id]) : item[h.id]}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

TableRowChildren.propTypes = {
  detach: PropTypes.string.isRequired,
  header: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      align: PropTypes.oneOf(['left', 'center', 'right']),
      formatted: PropTypes.func,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  onCallback: PropTypes.func.isRequired,
};
